import * as Sentry from "@sentry/react";
import { useEffect } from "react";

export interface RouteErrorBoundaryProps {
  readonly error: unknown;
}

// Friendly, app-wide fallback for uncaught route errors. Wired as the router's
// `defaultErrorComponent` so any route that throws during load or render shows a
// recoverable message instead of a blank screen.
export function RouteErrorBoundary({ error }: RouteErrorBoundaryProps) {
  // Report the error to Sentry once per distinct error. Rendering the fallback
  // means the error was otherwise swallowed by the router, so this is the only
  // place it gets captured.
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const detail = error instanceof Error ? error.message : "Onbekende fout";

  return (
    <main className="mx-auto flex min-h-[60vh] max-w-5xl flex-col items-center justify-center gap-2 px-6 text-center">
      <div role="alert" className="space-y-2">
        <h1 className="font-display text-3xl font-bold tracking-tight">
          Er ging iets mis
        </h1>
        <p className="text-muted-foreground">{detail}</p>
      </div>
    </main>
  );
}
